import { PopperContent } from '@/components/poppers/PopperContent';
import { useViewOnly } from '@/contexts/InteractionParadigm.context';
import { ContextualHelpTooltip } from '@/modules/content/components/ContextualHelpTooltip';

export function NetWorthInsuranceTooltip() {
  // Hide in client-facing presentations/exports.
  const isViewOnly = useViewOnly();
  if (isViewOnly) return null;

  return (
    <ContextualHelpTooltip>
      <PopperContent body="Reflects the net value of any liabilities and receivables." />
    </ContextualHelpTooltip>
  );
}
